import R from 'ramda';

import companydocumentstemplate from './documents.tpl.html';
import { getCompanyById } from '../../../../reducers/companies';
import { getTotal, getLoading as getBILoading } from '../../../../reducers/businessInformations';
import { getLoading as getQuestionnairesLoading } from '../../../../reducers/questionnaires';
import { getLoading as getTILoading } from '../../../../reducers/techDoc';

export class CompanyDocuments {
  constructor($scope, $ngRedux,
    actionsFactory, $translate, questionnaireService, companiesService) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
      questionnaireService,
      companiesService,
      tableInit: false,
    });
    const unsubscribe = $ngRedux.connect(CompanyDocuments.mapStateToThis, actionsFactory)(this);
    $scope.$on('$destroy', unsubscribe);
  }
  static mapStateToThis(state) {
    return {
      auth: state.authentication,
      company: getCompanyById(state, state.router.currentParams.id),
      loadingQuestionnaires: getQuestionnairesLoading(state),
      loadingTechnicalInformations: getTILoading(state),
      loadingBusinessInformations: getBILoading(state),
      router: state.router,
      enums: state.enums,
      biTotal: getTotal(state),
    };
  }

  goTo(state, params) {
    this.state(state, params);
  }

  $onInit() {
    this.searchColumns = [
      {
        id: 'buyer_name',
        type: 'text',
        labelKey: 'BUSINESS_BUYERNAME',
        fields: ['buyer.firstName', 'buyer.lastName'],
        sortable: true,
        width: '30%',
      },
      {
        type: 'text',
        id: 'requesting_company',
        fields: ['buyer.company.name'],
        labelKey: 'BUSINESS_REQUESTINGCOMPANY',
        sortable: true,
        width: '30%',
      },
      {
        type: 'semaphore',
        id: 'activeStatus',
        labelKey: 'GENERIC_REGISTRATIONSTATUS',
        statuses: 'statuses.bi',
        width: '30%',
      },
      {
        type: 'button',
        id: 'gotodetail',
        cssClass: 'tct-icon tct-icon__eye',
        onClick: id => this.goTo('authenticated.company.detail.businessInfo', { businessInfoId: id }),
        width: '10%',
      },
    ];
    this.searchParams = [
      {
        searchKey: 'BUSINESS_BUYERNAME_SEARCH',
        type: 'input',
        input: '',
        id: 'buyer_name',
      },
      {
        searchKey: 'BUSINESS_REQUESTINGCOMPANY',
        input: '',
        id: 'company_name',
        type: 'input',
      },
      {
        searchKey: 'BUSINESS_STATUS',
        input: '',
        id: 'status',
        type: 'select',
        options: [],
      },
    ];

    this.showConfirmationModal = false;
    this.reqEnumList('statuses.bi');
    this.reqEnumList('statuses.tech');
    this.reqEnumList('statuses.questionnaire');

    if (this.isLoggedInUserOfType(['editor'])) {
      this.reqTechDocList(this.router.currentParams.id);
      this.reqBusinessInfo(this.router.currentParams.id, { sort: { buyer_name: '', company_name: '' }, search: { buyer_name: '', company_name: '' } });
    }

    this.reqQuestionnaireListStart(this.router.currentParams.id);
  }

  $doCheck() {
    if (this.tableInit) {
      return;
    }

    if (this.searchParams[2].options.length) {
      this.tableInit = true;
      return;
    }

    if (this.enums && this.enums.statuses && this.enums.statuses.bi) {
      this.searchParams[2].options = CompanyDocuments.mapStatuses(this.enums.statuses.bi);
      this.searchParams[2].options.unshift({
        key: 'GENERIC_SHOWALL',
        value: '',
      });
      this.tableInit = true;
    }
  }

  openConfirmationModal(questionnaireId, userId) {
    this.showConfirmationModal = true;
    this.editingData = {
      questionnaireId,
      userId,
    };
  }

  assignUser() {
    this.assignContactUser(this.editingData.questionnaireId, this.editingData.userId);
    this.hideConfirmationModal();
  }

  hideConfirmationModal() {
    this.editingData = {};
    this.showConfirmationModal = false;
  }

  searchBusinessInfo(paramList) {
    this.reqBusinessInfo(this.router.currentParams.id, paramList);
  }

  removeDoc(doc) {
    this.removeTechDoc(this.router.currentParams.id, doc.id);
  }

  checkQuestionnaire(id) {
    this.goTo('authenticated.company.detail.questionnaire', { questionnaireId: id });
  }

  canEnterQuestionnaireDetails(questionnaire) {
    const statusesForEditors = [
      'draft',
      'reviewing',
      'approved',
    ];

    const userTypesForCompletedQuestionnaires = [
      'master',
      'director',
      'buyer',
    ];
    return (this.isLoggedInUserOfType(['editor']) && R.contains(questionnaire.status, statusesForEditors)) ||
      (this.isLoggedInUserOfType(userTypesForCompletedQuestionnaires) && R.contains(questionnaire.status, ['approved'])) ||
      (this.isLoggedInUserOfType(['base']) && questionnaire.contactUser && questionnaire.contactUser.id === this.auth.user.id);
  }

  static mapStatuses(statuses) {
    return R.map(toKeyVal, R.toPairs(statuses));

    function toKeyVal(pair) {
      return {
        key: pair[1],
        value: pair[0],
      };
    }
  }

  isLoggedInUserOfType(types) {
    return R.contains(this.auth.user.type, types);
  }

  mapQuestionnaireStatuses(statuses) {
    const statusPairs = R.toPairs(statuses.statuses);
    this.statusPairs = statusPairs;

    const yellowStatuses = R.map(element => element[0],
      statusPairs.slice(1, statusPairs.length - 1));

    return {
      red: statusPairs.length > 0 ? [statusPairs[0][0]] : [],
      yellow: statusPairs.length > 1 ? yellowStatuses : [],
      green: statusPairs.length > 0 ? [statusPairs[statusPairs.length - 1][0]] : [],
    };
  }
}

CompanyDocuments.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
  'questionnaireService',
  'companiesService',
];

export const companyDocuments = {
  template: companydocumentstemplate,
  controller: CompanyDocuments,
};
